// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2MCsH","noInteraction":"EventWrapper_noInteraction__aTXRU","pointerPassthrough":"EventWrapper_pointerPassthrough__3Sxn_"};